import { render, staticRenderFns } from "./OrderFiltersModal.vue?vue&type=template&id=418b40b4&scoped=true&"
import script from "./OrderFiltersModal.vue?vue&type=script&lang=ts&"
export * from "./OrderFiltersModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderFiltersModal.vue?vue&type=style&index=0&id=418b40b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b40b4",
  null
  
)

export default component.exports